module.exports = __webpack_public_path__ + "static/media/star-christmas.dc651d41.svg";